import React, { Component } from 'react'
import UserForm from '../_Components/UserForm'
import UserDetailsCard from '../_Components/UserDetailsCard';

import { connect } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { usersService } from '../../../../_services/users.service';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import httpStatus from 'http-status';

class EditUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      data: {},
      errors: {},
      loading: false,
      base64Profile: null,
      isElemFocused: false,
      showRoleDetails: false,
    }
    this.userCardRef = React.createRef(null)
    this.roleDetailsRef = React.createRef(null)

    this.handleSave = this.handleSave.bind(this)
    this.handleSetState = this.handleSetState.bind(this)
    this.handleCurrentlyFocused = this.handleCurrentlyFocused.bind(this)
    this.handleToggleRoleDetails = this.handleToggleRoleDetails.bind(this)
  }

  componentDidMount() {
    const { history, dispatch } = this.props
    if (history && history.location.state && history.location.state.user) {
      this.setState({
        user: history.location.state.user,
        data: history.location.state.user 
      })
    } else {
      history.push('/account/users')

      dispatch(alertActions.error('Please select a user to edit.'))
    }
  }

  handleSetState(value) {
    this.setState({data: {...this.state.data, ...value}})
  }

  handleSave() {
    let errors = {}
    this.props.dispatch(alertActions.clear())

    if (this.state.data.firstName === '') {
      errors.firstName = 'Please enter a first name.'
    }
    if (this.state.data.lastName === '') {
      errors.lastName = 'Please enter a last name.'
    }
    if (this.state.data.userType === 'Licensed' && !this.state.data.specialtyId) {
      errors.specialtyId = 'Please select a specialty.'
    }
    if (!this.state.data.roleId) {
      errors.roleId = 'Please select a role.'
    }
    if (this.state.data.username === '') {
      errors.username = 'Please enter a username.'
    }

    this.setState({errors: errors})

    if (Object.values(errors).length === 0) {
      this.setState({ loading: true })

      const { role, ...data } = this.state.data;

      usersService.updateUser(this.state.user.userId, data)
        .then(() => {
          this.props.history.push(`/account/users/${this.state.user.userId}`)
          this.props.dispatch(alertActions.success('User updated.'));
        })
        .catch((error) => {
          if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
            this.props.dispatch(alertActions.error(error.response.data.message));

            this.setState({ errors: error.response.data.errors })
          } else {
            this.props.dispatch(alertActions.error('Could not update user at this time. Please try again.'));
          }
        })
        .then(() => {
          this.setState({loading: false})
        })
    }
  }

  handleCurrentlyFocused(focused) {
    this.setState({isElemFocused: focused ? true : false})
    if (focused) {
      const offsetTop = document.getElementsByName(focused)[0].getBoundingClientRect().top
      this.userCardRef.current.style.top = (window.scrollY + offsetTop - 229) + 'px'
    }
  }

  handleToggleRoleDetails(value) {    
    this.setState({showRoleDetails: value})
    const offsetTop = document.getElementsByName('role')[0].getBoundingClientRect().top
    this.roleDetailsRef.current.style.top = (window.scrollY + offsetTop - 229) + 'px'
  }

  render() {
    const { user, data } = this.state;

    return (
      <>
        <Row>
          <Col>
            <UserDetailsCard user={user}>
              { this.state.userType === 'Staff' && 
                <>
                  <Row className='mt-4'>
                    <Col>
                      Public Identity:
                    </Col>
                  </Row>
                  <Row>
                    <Col className='text-muted font-weight-light'>
                      {`${user.publlicIdentity ? 'Display' : 'Hide'} Identity`}
                    </Col>
                  </Row>
                </>
              }
            </UserDetailsCard>
          </Col>

          <Col xs='9'>
            <div className='lead py-2 mb-4'>Edit User</div>

            <UserForm 
              edit={true}
              state={data}
              errors={this.state.errors}
              userType={data.userType}
              setParentState={this.handleSetState}
              profileImage={data.profileImage}
              publicIdentity={data.publicIdentity}
              currentlyFocused={() => {}}
              toggleRoleDetails={() => {}}
            >
              <Row className='mt-5'>
                <Col xs='4'>
                  <Button disabled={this.state.loading} onClick={this.handleSave} block variant='success'>
                    { this.state.loading ? <Spinner size='sm' animation='border' /> : 'Save User'}
                  </Button>
                </Col>
                <Col xs='3'>
                  <Button disabled={this.state.loading} onClick={() => this.props.history.goBack()} block variant='outline-primary'>Cancel</Button>
                </Col>
              </Row>
            </UserForm>
          </Col>
        </Row>
      </>
    )
  }
}

export default connect()(EditUser);